import Container from '@mui/material/Container';
import { Outlet } from 'react-router';

export function RootLayout() {
  return (
    <Container
      component="main"
      sx={(theme) => ({
        position: 'relative',
        padding: theme.spacing(8, 4),
      })}
    >
      <Outlet />
    </Container>
  );
}
